import { render, staticRenderFns } from "./selectblock.vue?vue&type=template&id=8615003a&"
import script from "./selectblock.vue?vue&type=script&lang=js&"
export * from "./selectblock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports